export default "__VITE_ASSET__kRtUbry$__"